var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAPlus = function SvgAPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h58v32H0zm58 0 18 15.5L58 32V0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.81 22h2.574L17.632 9.22h-2.628L10.252 22h2.466l1.26-3.6h4.572l1.26 3.6Zm-5.148-5.526 1.602-4.59 1.602 4.59h-3.204Zm15.632-5.088h-2.45V8.95H26.43v2.436h-2.436v1.428h2.436v2.436h1.414v-2.436h2.45v-1.428Z",
    fill: "#fff"
  })));
};
export default SvgAPlus;